import React, { PureComponent } from 'react'
import styled from 'styled-components'
import YouTubePlayer from 'react-player/lib/players/YouTube'
import TrackVisibility from 'react-on-screen'

const Video = styled(TrackVisibility)``

export default class VideoComponent extends PureComponent {
  render () {
    return (
      <Video>
        {({ isVisible }) => (
          <YouTubePlayer
            width='100%'
            height={500}
            url={this.props.data}
            playing={isVisible}
          />
        )}
      </Video>
    )
  }
}
